var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRevert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 6,
    viewBox: "0 0 14 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 0.333984C5.56732 0.333984 3.96732 0.993985 2.73398 2.06732L1.47398 0.807318C1.05398 0.387318 0.333984 0.680651 0.333984 1.27398V5.00065C0.333984 5.36732 0.633984 5.66732 1.00065 5.66732H4.72732C5.32065 5.66732 5.62065 4.94732 5.20065 4.52732L3.92732 3.25398C4.85398 2.48065 6.03398 2.00065 7.34065 2.00065C9.44732 2.00065 11.2673 3.22732 12.134 5.00065C12.314 5.37398 12.7407 5.56065 13.134 5.42732C13.6073 5.27398 13.8473 4.73398 13.634 4.28065C12.4873 1.94732 10.1007 0.333984 7.33398 0.333984Z",
    fill: "#575C5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevert);
export default __webpack_public_path__ + "static/media/icon-revert.7a79782f2707f90ff5648c0133ecf014.svg";
export { ForwardRef as ReactComponent };